module.exports = __webpack_public_path__ + "media/images/application/template/products/homepage_20ft_desktop-de57f536d4b3e87cda10e6b85a76e01d.png";